import { Alert, AlertDescription, AlertTitle } from "@coval/ui/alert"
import { Button } from "@coval/ui/button"
import { Card, CardContent } from "@coval/ui/card"
import { Skeleton } from "@coval/ui/skeleton"

export function OverageSettingsVerification({
  failed,
  onRetry,
}: {
  failed: boolean
  onRetry: () => void
}) {
  return (
    <Card>
      <CardContent className="p-6">
        {failed ? (
          <Alert variant="danger">
            <AlertTitle>
              Couldn't verify this organization's settings
            </AlertTitle>
            <AlertDescription>
              Check your organization access and retry. No settings have been
              changed.
            </AlertDescription>
            <Button variant="secondary" className="mt-3" onClick={onRetry}>
              Retry organization lookup
            </Button>
          </Alert>
        ) : (
          <div
            role="status"
            aria-label="Verifying overage settings organization"
          >
            <Skeleton className="h-24 w-full" />
          </div>
        )}
      </CardContent>
    </Card>
  )
}
